import styled from "styled-components"
import DirectFreshLogo from "../assets/logos/direct-fresh-logo.png"
import ThriveLogo from "../assets/logos/thrive-logo.png"
import { phoneWidth } from "../Globalstyle"

const StyledDonationLink = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: var(--side-padding);
  align-items: center;
  gap: 5rem;

  @media (max-width: ${phoneWidth}) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 10rem;
`

const Title = styled.div`
  font-size: 2rem;
  font-weight: bold;
`

const Description = styled.div``

const LogoButtonRedirect = styled.a`
  width: 16rem;
  height: 8rem;
  border: 0.15rem solid var(--green);
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

  @media (max-width: ${phoneWidth}) {
    width: 100%;
  }
`

const LogoContainer = styled.div`
  height: 8rem;
`

const ButtonLogo = styled.img`
  height: 50%;
`

const StyledInfo = styled.div`
  background-color: var(--tan);
  padding: var(--side-padding);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${phoneWidth}) {
    flex-direction: column;
    gap: 2rem;
  }
`

const Logo = styled.img`
  height: 100%;
`

const Info = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 1rem;
`

const DonationLinks = () => {
  return (
    <>
      <StyledDonationLink>
        <Text>
          <Title>
            Donate Now
          </Title>
          <div>
            Make a contribution through Thrive.
          </div>
        </Text>
        <LogoButtonRedirect href="https://www.classy.org/give/225869/#!/donation/checkout" target="_blank">
          <ButtonLogo src={ThriveLogo} alt="Thrive Logo"/>
        </LogoButtonRedirect>
      </StyledDonationLink>
      <StyledInfo>
        <Info>
          <Title>
            Learn More
          </Title>
          <Description>
            <div>
              Tahmina Akter Mim
            </div>
            <div>
              Phone: 01747504234
            </div>
          </Description>
        </Info>
        <LogoContainer>
          <Logo src={DirectFreshLogo} alt="Direct Fresh Logo"/>
        </LogoContainer>
      </StyledInfo>
    </>
  )
}

export default DonationLinks